<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12" id="main">
        <ul id="properties-menu" class="nav nav-pills nav-fill">
          <li v-for="property in properties" v-bind:key="property._id">
            <router-link :class="target === property._id ? 'nav-item nav-link active':'nav-item nav-link'"
              :to="'/story/' + id + '/' + property._id">{{ property.title }}</router-link>
          </li>
          <li v-for="property in unauthorizedProperties" v-bind:key="property._id">
            <a v-on:click.stop.prevent="openModal(property)" class="nav-item nav-link disabled"
              :href="'/story/' + id + '/' + property._id">{{ property.title }}</a>
          </li>
        </ul>
        <div v-if="isLinked()" class="alert alert-warning" role="alert">
          <h5 class="alert-heading">Warning</h5>
          <div>This story is already linked in {{property.title}}. If you continue you may create duplicate content in
            {{property.title}}</div>
        </div>
        <form v-if="property._id">
          <div class="row">
            <div class="col-9">
              <div class="form-group">
                <label for="title">Title</label>
                <input type="text" class="form-control" required id="title" placeholder="Title" v-model="row.title" />
                <small class="form-text text-muted">This is the title that will be used on{{property.title}}. Max
                  Characters: 70</small>
              </div>
              <div class="form-group">
                <label for="text">Intro text</label>
                <editor v-model="row.intro"
                  :init="{plugins: 'wordcount link', height: '100', entity_encoding: 'raw', 'inline_styles': false, 'invalid_elements':'script,applet,span,font,picture,h1,form,input', 'extended_valid_elements':'div[!class|class<playbuzz?apester-media|width|height]'}">
                </editor>
                <small class="form-text text-muted">This is the intro text that will be used on
                  {{property.title}}.</small>
              </div>
              <div class="form-group">
                <label for="text">Text</label>
                <editor v-model="row.text"
                  :init="{plugins: 'wordcount link', height: '200', entity_encoding: 'raw', 'inline_styles': false, 'invalid_elements':'script,applet,span,font,picture,h1,form,input', 'extended_valid_elements':'div[!class|class<playbuzz?apester-media|width|height]'}">
                </editor>
                <small class="form-text text-muted">This is the text that will be used on {{property.title}}.</small>
              </div>
              <div class="form-group">
                <button v-if="sending" type="submit" class="btn btn-primary disabled" disabled>Sending to
                  {{property.title}}</button>
                <button v-else type="submit" class="btn btn-primary" v-on:click.stop.prevent="save">Send to
                  {{property.title}}</button>
              </div>
            </div>
            <div class="col-3">
              <div class="form-group">
                <label for="image">Image</label>
                <div>
                  <croppa v-model="cropper" :width="imageWidth" :height="imageHeight" :quality="4"
                    placeholder="Choose an image" :disabled="false" :prevent-white-space="true"
                    :show-remove-button="true" :initial-image="image"></croppa>
                </div>
                <small class="form-text text-muted">This is the image that will be used on {{property.title}}. Use the
                  mouse wheel to zoom in/out. Drag the image to crop it.</small>
              </div>
              <div class="form-group">
                <label for="catid">Category *</label>
                <v-select v-model="category" placeholder="Select" :options="categories"></v-select>
                <small class="form-text text-muted">Select the category on {{property.title}}.</small>
              </div>
              <div class="form-group">
                <label for="publish_up">Start Publishing</label>
                <flat-pickr id="publish_up" aria-describedby="publish_up_help" v-model="row.published"
                  :config="calendar" class="form-control" placeholder="Select date" name="date"></flat-pickr>
                <small id="publish_up_help" class="form-text text-muted">The publish date of the target story should
                  always be greater than the the publish date of the source story.</small>
              </div>
              <div class="form-group">
                <label for="created_by">Author</label>
                <v-select v-model="user" placeholder="Me" :options="users"></v-select>
                <small class="form-text text-muted">Select the author on {{property.title}}.</small>
              </div>
              <div class="form-group">
                <label for="created_by_alias">Custom Author</label>
                <input type="text" class="form-control" required id="created_by_alias" v-model="row.created_by_alias" />
              </div>
            </div>
          </div>
        </form>
        <div class="alert alert-primary" role="alert" v-else>Please select a property first from the menu</div>
      </div>
    </div>

    <div :class="this.modal ? 'modal fade show': 'modal fade'" tabindex="-1" role="dialog"
      :aria-hidden="this.modal ? 'false' : 'true'" :style="this.modal ? 'display: block;':''">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Login to {{modalProperty.title}}</h5>
            <button type="button" class="close" aria-label="Close" @click.stop.prevent="closeModal">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body p-5 joomla-login">
            <div v-if="modalError" class="alert alert-danger" role="alert">{{modalError}}</div>
            <div class="card bg-light">
              <div class="card-body">
                <form>
                  <div class="form-group">
                    <input type="text" required="true" v-model="modalUsername" placeholder="Username"
                      class="form-control" id="username" />
                  </div>
                  <div class="form-group">
                    <input type="password" required="true" v-model="modalPassword" placeholder="Password"
                      class="form-control" id="password" />
                  </div>
                  <div class="form-group">
                    <button type="submit" class="btn btn-primary btn-block" :disabled="modalButtonDisabled"
                      @click.stop.prevent="authoriseProperty" style="background-color:#2384d3">Log in</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import Vue from 'vue';
import {
  api
} from '../api.js';
import ui from '../ui.js';
import axios from 'axios';

import Editor from '@tinymce/tinymce-vue';

import ToggleButton from 'vue-js-toggle-button';
Vue.use(ToggleButton);

import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

import 'vue-croppa/dist/vue-croppa.css';
import Croppa from 'vue-croppa';
Vue.use(Croppa);

import {
  DateTime
} from 'luxon';
import vSelect from 'vue-select';
export default {
  name: 'Story',
  props: ['id', 'target'],
  components: {
    'editor': Editor,
    'flatPickr': flatPickr,
    'vSelect': vSelect
  },
  data: function () {
    return {
      row: {},
      property: {},
      token: '',
      authorization: '',
      cropper: {},
      image: null,
      imageWidth: 300,
      imageHeight: 300,
      calendar: {
        wrap: true,
        enableTime: true,
        time_24hr: true,
        dateFormat: 'Y-m-d H:i',
        altFormat: 'J F Y - H:i',
        altInput: true,
        minDate: '2000-01'
      },
      properties: [],
      unauthorizedProperties: [],
      keys: [],
      categories: [],
      category: '',
      users: [],
      user: '',
      links: [],
      sending: false,
      modal: false,
      modalProperty: {
        title: ''
      },
      modalUsername: '',
      modalPassword: '',
      modalButtonDisabled: false,
      modalError: ''
    }
  },
  mounted: function () {
    this.initialize();
  },
  watch: {
    target: function () {
      this.category = '';
      this.user = '';
      this.setLinks();
      this.setProperty();
      this.setToken();
      this.setCategories();
      this.setUsers();
      this.setImageDimensions();
    }
  },
  methods: {
    initialize: function () {

      this.properties = [];
      this.unauthorizedProperties = [];
      this.keys = [];

      let promises = [];
      promises.push(api.get('/keys', {
        params: {
          user: this.$store.state.id,
          limit: 20
        }
      }));
      promises.push(api.get('/stories/' + this.id, {}));
      promises.push(api.get('/properties', {
        params: {
          limit: 20
        }
      }));


      Promise.all(promises).then(([response1, response2, response3]) => {
        this.keys = response1.data.docs;
        let valid = this.keys.map(x => x.property);

        var storyData = response2.data;
        let minDate = DateTime.fromISO(storyData.published, {
          zone: 'Europe/Athens'
        });
        storyData.published = minDate.plus({
          minutes: 10
        }).toFormat('yyyy-MM-dd HH:mm');
        this.setStory(storyData);
        this.calendar.minDate = storyData.published;

        response3.data.docs.forEach((property) => {
          if (valid.indexOf(property._id) !== -1 && storyData.property._id != property._id) {
            this.properties.push(property);
          } else {
            this.unauthorizedProperties.push(property);
          }
        });

        if (this.target) {
          this.setLinks();
          this.setProperty();
          this.setToken();
          this.setCategories();
          this.setUsers();
          this.setImageDimensions();
        } else if (this.properties.length) {
          this.$router.push('/story/' + this.id + '/' + this.properties[0]._id);
        }

      });
    },
    setStory: function (data) {
      this.row.published = data.published;
      this.row.title = data.title;
      this.row.intro = data.teaser;
      this.row.text = data.text + '<p>Διαβάστε περισσότερα στο <a href="' + data.url + '" rel="noopener" target="_blank">' + data.property.title + '</a></p>';
      this.row.metadesc = data.metadata.description;
      this.row.metadata = {
        canonical: data.url,
        browser_title: data.metadata.title,
        facebook_title: data.metadata.og_title,
        facebook_description: data.metadata.og_description
      };

      var imageUrl = data.image;
      var imageName = imageUrl.substring(imageUrl.lastIndexOf('/') + 1);
      var parts = imageName.split('.');
      this.row.image_name = parts[0];

      var image = new Image();
      image.setAttribute('crossorigin', 'anonymous');
      image.setAttribute('src', data.image);
      this.image = image;
      this.row.created_by = '';
    },


    setToken: function () {
      this.token = '';
      this.keys.forEach((key) => {
        if (key.property === this.target) {
          this.token = key.key;
        }
      });
    },
    setProperty: function () {
      this.properties.forEach((property) => {
        if (property._id === this.target) {
          this.property = property;
        }
      });
    },
    setUsers: function () {
      axios.get(this.property.endpoint + '/index.php?option=com_rest&resource=users.users&format=json', {
        headers: {
          'Authorization': this.getAuthorizationHeader()
        }
      }).then((response) => {
        this.users = [];
        response.data.data.forEach((doc) => {
          this.users.push({
            label: doc.name,
            value: doc.id
          });
        });
      }).catch(() => {
        this.users = [];
        ui.alert('Σφάλμα κατα τη λήψη των χρηστών του ' + this.property.title);
      });
    },
    setCategories: function () {
      axios.get(this.property.endpoint + '/index.php?option=com_rest&resource=categories.categories&format=json', {
        headers: {
          'Authorization': this.getAuthorizationHeader()
        }
      }).then((response) => {
        let prefix = '-';
        this.categories = [];
        response.data.data.forEach((doc) => {
          this.categories.push({
            label: prefix.repeat(doc.level) + doc.title,
            value: doc.id
          });
        });
      }).catch(() => {
        this.categories = [];
        ui.alert('Σφάλμα κατα τη λήψη των κατηγοριών του ' + this.property.title);
      });
    },
    setImageDimensions: function () {
      let parts = this.property.ratio.split('/');
      let ratio = parts[1] / parts[0];
      this.imageHeight = this.imageWidth * ratio;
    },
    setLinks: function () {
      api.get('/links', {
        params: {
          story: this.id
        }
      }).then((response) => {
        this.links = response.data;
      }).catch(() => { });
    },
    getAuthorizationHeader: function (modal) {
      let parts = [];
      let property = modal === true ? this.modalProperty : this.property;
      if (property.authorization) {
        parts.push('Basic ' + btoa(property.authorization));
      }
      if (this.token) {
        parts.push('Bearer ' + this.token);
      }
      return parts.join(',');
    },
    save: function () {

      if (this.row.title.length > 70) {
        ui.alert('Ο τίτλος είναι πολύ μεγάλος');
        return;
      }

      this.sending = true;

      if (!this.token || !this.property || !this.property.endpoint) {
        ui.alert('Κάτι πήγε στραβά!');
        this.sending = false;
        return;
      }

      if (!this.category) {
        ui.alert('Please select a category');
        this.sending = false;
        return;
      }

      this.row.image = this.cropper.generateDataUrl('image/jpeg', 1);
      this.row.state = 1;
      this.row.catid = this.category.value;
      var published_local = DateTime.fromSQL(this.row.published, {
        zone: 'Europe/Athens'
      });
      var published_utc = published_local.setZone('utc');
      this.row.publish_up = published_utc.toFormat('yyyy-MM-dd HH:mm');

      if (this.user) {
        this.row.created_by = this.user.value;
      } else {
        this.row.created_by = '';
      }

      axios.post(this.property.endpoint + '/index.php?option=com_rest&resource=news.stories&format=json', this.row, {
        headers: {
          'Authorization': this.getAuthorizationHeader()
        }
      }).then(() => {
        ui.alert('Το άρθρο αποθηκέυτηκε στο ' + this.property.title);
        this.sending = false;
        api.post('/links', {
          story: this.id,
          property: this.target
        });

      }).catch(() => {
        ui.alert('Κάτι πήγε στραβά');
        this.sending = false;
      });

    },
    isPublished: function (value) {
      let publishTime = DateTime.fromISO(value);
      let now = DateTime.local();
      return publishTime < now;
    },
    isLinked: function () {
      var result = false;
      this.links.forEach((link) => {
        if (link.property === this.target) {
          result = true;
        }
      });
      return result;
    },

    openModal: function (property) {
      this.modalProperty = property;
      this.modalUsername = '';
      this.modalPassword = '';
      this.modalButtonDisabled = false;
      this.modalError = '';
      this.modal = true;
    },

    closeModal: function () {
      this.modal = false;
    },

    authoriseProperty: function () {

      this.modalButtonDisabled = true;

      var loginData = {
        username: this.modalUsername,
        password: this.modalPassword
      };
      axios.post(this.modalProperty.endpoint + '/index.php?option=com_rest&task=login&format=json', loginData, {
        headers: {
          'Authorization': this.getAuthorizationHeader(true)
        }
      }).then((response) => {

        var keyData = {
          key: response.data.data.key,
          property: this.modalProperty._id,
          user: this.$store.state.id
        }

        api.post('/keys', keyData).then(() => {
          this.modal = false;
          window.location.reload();

        }).catch(function (error) {
          this.modalButtonDisabled = false;
          ui.alert(error.response.data);
        });

      }).catch((error) => {

        this.modalButtonDisabled = false;

        if (error.response && error.response.status === 401) {
          this.modalError = 'Ανεπιτυχής σύνδεση.';
        } else if (error.response && error.response.status === 403) {
          this.modalError = 'Τα στοιχεία είναι σωστά αλλά δε σας έχει δωθεί πρόσβαση interlinking στο συγκεκριμένο site. Παρακαλώ επικοινωνήστε με τους διαχειριστές και δοκιμάστε ξανά.';
        } else {
          this.modalError = 'Κάτι πήγε στραβά';
        }
      });

    }

  }
}
</script>
<style>
.joomla-login {
  background-color: #17568c;
}
</style>
